import React, { useState } from 'react';

function ModifileUnit({
  dataArr = {},
  title = 'title',
  seletedval = '',
  calback,
}) {
  const [val, setVal] = useState(seletedval);
  const handleCalback = (e) => {
    setVal(e.target.value);
    if (calback) calback(e.target.value);
  };
  return (
    <div className="width100 grid-sec">
      <span className="width100">{title}:</span>
      <span className="width100">
        <select
          className="mod-dd"
          value={val}
          onChange={(e) => handleCalback(e)}
        >
          <option value="">{''}</option>
          {dataArr?.map((d, i) => (
            <option key={i} value={d.id}>
              {d.modifierName}
            </option>
          ))}
        </select>
      </span>
    </div>
  );
}

export default ModifileUnit;
